import {pxToRem} from '../../../utills/pxToRem'
import {fonts} from '../../foundations/fonts'

const commonStyles = {
    borderRadius: 'none',
    fontFamily: fonts.primary,
    height: [pxToRem(35), pxToRem(40)],
    padding: [`${pxToRem(10)} ${pxToRem(20)}`, `${pxToRem(12)} ${pxToRem(20)}`],
    fontWeight: 700,
    textTransform: 'uppercase',
    textAlign: 'center',
    fontSize: [pxToRem(12), pxToRem(14)],
    fontStyle: 'normal',
    lineHeight: pxToRem(13.5),
    letterSpacing: pxToRem(1.5)
}

export default {
    baseStyle: {
        borderRadius: 'base'
    },

    variants: {
        solid: (props) =>
            props.colorScheme === 'blue'
                ? {
                      backgroundColor: 'blue.600',
                      color: 'white',
                      _hover: {bg: 'blue.700', _disabled: {bg: 'blue.300'}},
                      _active: {bg: 'blue.800'},
                      _disabled: {bg: 'blue.300'}
                  }
                : {},
        outline: (props) =>
            props.colorScheme === 'black'
                ? {color: 'gray.900', _hover: {bg: 'gray.50'}, borderColor: 'gray.200'}
                : {color: 'blue.600', _hover: {bg: 'gray.50'}},
        footer: {
            fontSize: 'sm',
            backgroundColor: 'gray.100',
            color: 'black',
            _hover: {bg: 'gray.200'},
            _active: {bg: 'gray.300'},
            paddingLeft: 3,
            paddingRight: 3
        },
        link: (props) => ({
            color: props.colorScheme === 'red' ? 'red.500' : 'blue.600',
            fontWeight: 'normal',
            minWidth: '1em',
            lineHeight: 4
        }),
        'menu-link': {
            color: 'black',
            justifyContent: 'flex-start',
            fontSize: 'sm',
            _hover: {bg: 'gray.50', textDecoration: 'underline', textDecorationColor: 'gray.900'},
            _activeLink: {
                bg: 'gray.50',
                borderLeft: 'solid',
                borderLeftColor: 'gray.600',
                borderLeftWidth: '4px'
            }
        },
        'menu-link-mobile': {
            color: 'black',
            justifyContent: 'flex-start',
            fontSize: 'sm',
            _hover: {bg: 'gray.50', textDecoration: 'underline', textDecorationColor: 'gray.900'},
            _activeLink: {
                bg: 'gray.100',
                borderLeft: 'solid',
                borderLeftColor: 'cav_red',
                borderLeftWidth: '4px'
            }
        },
        'search-link': {
            color: 'black',
            justifyContent: 'flex-start',
            fontSize: 'sm',
            _hover: {textDecoration: 'none'}
        },
        // default red button
        red: {
            ...commonStyles,
            backgroundColor: 'cav_red',
            color: 'white',
            _hover: {bg: 'white', color: 'cav_red'},
            _active: {bg: 'white', color: 'cav_red'}
        },
        // white button
        white: {
            ...commonStyles,
            backgroundColor: 'white',
            color: 'cav_red',
            _hover: {bg: 'cav_red', color: 'white'},
            _active: {bg: 'cav_red', color: 'white'}
        },
        //brown button
        brown: {
            ...commonStyles,
            backgroundColor: 'cav_purple',
            color: 'white',
            _hover: {bg: 'white', color: 'cav_purple'},
            _active: {bg: 'white', color: 'cav_purple'}
        },

        'red-link-uline': {
            color: 'cav_red',
            fontFamily: fonts.primary,
            fontSize: [pxToRem(12), pxToRem(14)],
            fontStyle: 'normal',
            textTransform: 'uppercase',
            fontWeight: 700,
            lineHeight: pxToRem(13.5),
            letterSpacing: pxToRem(1.5),
            padding: 0,
            height: 'auto',
            textDecoration: 'underline'
        }
    },

    sizes: {
        md: {
            height: 11,
            minWidth: 11
        },
        base: {
            width: [pxToRem(260), pxToRem(295)]
        },
        full: {
            width: '100%'
        }
    },
    defaultProps: {
        colorScheme: 'blue'
    }
}
